module.exports = __webpack_public_path__ + "media/fonts/Lato-Bold-afad4de3605f5bb86d13bce2ca85d569.woff";